import { BaseResponse } from "../../../../../../../libs/common/src/models/response/base.response";

export class ClassificationResponse extends BaseResponse {
  __v: number;
  id: string;
  name: string;
  weight: number; // Link to the account AccountIdReference
  generalDefault?: boolean; // when we import data and create accounts if there are no classification related to transaction
  // we create a default classification as account has to have at least one default classification

  constructor(response: any) {
    super(response);
    this.__v = this.getResponseProperty("__v");
    this.id = this.getResponseProperty("_id");
    this.name = this.getResponseProperty("name");
    this.weight = this.getResponseProperty("weight");
    this.generalDefault = this.getResponseProperty("generalDefault");
  }
}
